export default "__VITE_ASSET__DrsTmyyg__"